// extracted by mini-css-extract-plugin
export var text = "_33-0";